interface IFormAdvisoryMessageParameters {
	message: string;
	bulletinPoints: string[];
}

export default class FormAdvisoryMessage {
	public message: string;
	public bulletinPoints: string[];

	public constructor(params: IFormAdvisoryMessageParameters) {
		this.message = params.message;
		this.bulletinPoints = params.bulletinPoints;
	}
}